import type { ISimulationPlanningCard } from '@/types';
import type { StepStatus } from './types';

/**
 * Determines the status of a planning step based on the active card
 */
export const getStepStatus = (
  stepNumber: number,
  activeCard: ISimulationPlanningCard | null,
): StepStatus => {
  if (!activeCard) return 'upcoming';
  if (stepNumber < activeCard.stepNumber) return 'completed';
  if (stepNumber === activeCard.stepNumber) return 'active';
  return 'upcoming';
};

/**
 * Calculates the normalized index of the active card for carousel positioning
 */
export const calculateActiveCardIndex = (
  planningCards: ISimulationPlanningCard[],
  activeCard: ISimulationPlanningCard | null,
): number => {
  const activeStepNumber = activeCard?.stepNumber;
  const activeCardIndex = planningCards.findIndex((c) => c.stepNumber === activeStepNumber);
  return Math.max(activeCardIndex, 0);
};

/**
 * Calculates the transform value for carousel slide animation
 */
export const calculateCarouselTransform = (
  normalizedActiveCardIndex: number,
  horizontalPaddingRem: number,
): string => {
  const translateXPercentage = -normalizedActiveCardIndex * 100;
  const translateXPadding = -normalizedActiveCardIndex * horizontalPaddingRem;
  return `translateX(calc(${translateXPercentage}% - ${translateXPadding}rem))`;
};
